import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons/faSpinnerThird';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Icon } from '../icon';
import GalleryIcon from 'public/assets/images/galleryIcon.svg';
export function Pending() {
    const { t } = useTranslation();
    return (_jsxs("div", { className: clsx('align-center flex items-center justify-between rounded-large border-radius border-small border-primary-400 bg-primary-100 px-4 py-3'), children: [_jsxs("div", { className: "flex items-center gap-2", children: [_jsx("img", { src: GalleryIcon, alt: "" }), _jsx("p", { className: "text-extrasmall font-bold text-neutral-900", children: t('upload_file.loading_file') })] }), _jsx(Icon, { icon: faSpinnerThird, spin: true, className: "text-primary-500" })] }));
}
